import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import Button from './Button'

function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  totalItems,
  showInfo = true,
  className = '',
}) {
  if (totalPages <= 1) return null

  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalItems)

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between gap-4 ${className}`}>
      {showInfo && (
        <div className="text-sm text-neutral-600 dark:text-neutral-400 text-center sm:text-left">
          Showing {startItem} to {endItem} of {totalItems} entries
        </div>
      )}

      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="flex-shrink-0"
        >
          <MdChevronLeft />
          <span className="hidden sm:inline">Previous</span>
        </Button>

        <div className="flex items-center gap-1 overflow-x-auto max-w-48 px-2">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <Button
              key={page}
              variant={currentPage === page ? 'primary' : 'outline'}
              size="sm"
              onClick={() => onPageChange(page)}
              className="w-8 h-8 p-0 flex-shrink-0"
            >
              {page}
            </Button>
          ))}
        </div>

        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="flex-shrink-0"
        >
          <span className="hidden sm:inline">Next</span>
          <MdChevronRight />
        </Button>
      </div>
    </div>
  )
}

export default Pagination
